import React, { useEffect } from 'react';

import { MapType } from '@strava/mre';

import { useMRE } from '../../hooks/useMRE';
import { useMREState } from '../../hooks/useMREState';
import { Flyover, FlyoverProps } from '../Flyover/Flyover';

interface FlyoverOnlyProps
  extends Pick<FlyoverProps, 'polyline' | 'elevation' | 'onProgressChanged'> {
  isWinterSport?: boolean;
}

export const FlyoverOnly = ({
  polyline,
  elevation,
  onProgressChanged,
  isWinterSport
}: FlyoverOnlyProps) => {
  const { setIsFlyoverInProgress, setMapType, flyoverEndTargetRef } =
    useMREState();
  const { terrainEngine } = useMRE();

  useEffect(() => {
    if (terrainEngine && flyoverEndTargetRef) {
      const currentTarget = terrainEngine.getCamera().getTarget();
      flyoverEndTargetRef.current = {
        ...currentTarget,
        // Change end target position to top-down view
        pitch: 0,
        bearing: 0
      };
    }

    // On flyover mount, set the map to satellite
    setMapType(
      isWinterSport
        ? MapType.STRAVA_SATELLITE_WINTER
        : MapType.STRAVA_SATELLITE_SUMMER
    );
    // and mark flyover as in progress to hide the controls
    setIsFlyoverInProgress(true);

    return () => {
      setIsFlyoverInProgress(false);
    };
    // Run only once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flyover
      polyline={polyline}
      elevation={elevation}
      playbackSpeedFactor={1.6}
      onProgressChanged={onProgressChanged}
    />
  );
};
